/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateNoteUpdate } from '../../axios/candidateNoteUpdate'
import type {
	CandidateNoteUpdateError,
	CandidateNoteUpdatePathParams,
	CandidateNoteUpdateRequest,
	CandidateNoteUpdateResponse,
} from '../../types/CandidateNoteUpdate'

export const candidateNoteUpdateMutationKey = () => [{ url: '/candidates/:candidate/notes/:note' }] as const

export type CandidateNoteUpdateMutationKey = ReturnType<typeof candidateNoteUpdateMutationKey>

export type CandidateNoteUpdateVariables = {
	candidate: CandidateNoteUpdatePathParams['candidate']
	note: CandidateNoteUpdatePathParams['note']
	data: CandidateNoteUpdateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::update */
export function useCandidateNoteUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateNoteUpdateResponse,
		AxiosError<CandidateNoteUpdateError>,
		CandidateNoteUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateNoteUpdateMutationKey(),
		mutationFn: ({ candidate, note, data }: CandidateNoteUpdateVariables) =>
			candidateNoteUpdate(candidate, note, data, config).then(res => res.data),
		...options,
	})
}
